import axios from 'axios';

export const PAGE_SIZE = 24;
export const BOOK_KIND = {
    ebook: 'ebook',
    book: 'book'
}

export function getBooksBySearchAll({
    searchValue = '',
    page = 1,
    bookKind
  }) {
    const urls = {
        [BOOK_KIND.ebook]: 'api/ebook/SearchLocal',
        [BOOK_KIND.book]: 'api/book/SearchLocalHaveCopy',
    };

    const url = `${window.getLinkHomepage()}${urls[bookKind]}`;
    return axios
      .post(url, {
        Search: searchValue,
        Index: (page - 1) * PAGE_SIZE,
        Count: PAGE_SIZE
      })
      .then((data) => data.data);
  }